import { ApiResponse } from 'modules/auth/interfaces/apiResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import store from '@/store';

export class DashboardApi {
  public getNewUsersData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/users/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getTransactionsCount(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/transactionsCount/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getPaymentMethodsData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/paymentMethods/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getShippingMethodsData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/shippingMethods/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getSessionsData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/sessions/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getUsersData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/users/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getTransactionsIncomeData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/transactionsIncome/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getTransactionsLostIncomeData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/transactionsLostIncome/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }

  public getCartAverageValueData(options: any) {
    let currentInstance = null;

    if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.current_instance) {
      currentInstance = store.state.auth.user.current_instance;
    }

    if (currentInstance) {
      const endpointUrl = '/instance/cartAverageValue/' + currentInstance;
      return AuthorizedApiClient.post(endpointUrl, options).then((response: ApiResponse) => {
        if (response.status === 200) {
          const responseData = response.data;

          if (responseData.success) {
            return responseData.data;
          } else {
            return responseData.message;
          }
        } else {
          return [];
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }
  }
}
